var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon16PxDashboardOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0772 7.5769H9.69261C9.45895 7.5769 9.26953 7.76633 9.26953 7.99998V13.0769C9.26953 13.3106 9.45895 13.5 9.69261 13.5H13.0772C13.3108 13.5 13.5003 13.3106 13.5003 13.0769V7.99998C13.5003 7.76633 13.3108 7.5769 13.0772 7.5769Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0772 2.5H9.69261C9.45895 2.5 9.26953 2.68942 9.26953 2.92308V4.62386C9.26953 4.85751 9.45895 5.04694 9.69261 5.04694H13.0772C13.3108 5.04694 13.5003 4.85751 13.5003 4.62386V2.92308C13.5003 2.68942 13.3108 2.5 13.0772 2.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30769 2.5H2.92308C2.68942 2.5 2.5 2.68942 2.5 2.92308V8.00003C2.5 8.23368 2.68942 8.42311 2.92308 8.42311H6.30769C6.54135 8.42311 6.73076 8.23368 6.73076 8.00003V2.92308C6.73076 2.68942 6.54135 2.5 6.30769 2.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30769 10.9529H2.92308C2.68942 10.9529 2.5 11.1423 2.5 11.376V13.0767C2.5 13.3104 2.68942 13.4998 2.92308 13.4998H6.30769C6.54135 13.4998 6.73076 13.3104 6.73076 13.0767V11.376C6.73076 11.1423 6.54135 10.9529 6.30769 10.9529Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16PxDashboardOutline);
export default __webpack_public_path__ + "static/media/icon_16px_dashboard_outline.f0a52ccef0bc62369917c945f684b056.svg";
export { ForwardRef as ReactComponent };